<template>
  <div>
    <el-button type="text" size="small" @click="openSee">
      <slot></slot>
    </el-button>

    <el-dialog
        title="条码信息"
        :visible.sync="openStatus"
        width="80%"
        :fullscreen="true"
        :modal-append-to-body="true"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :destroy-on-close="true"
        :before-close="closeSee"
    >
      <div>
        {{ list }}
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  components: {},
  data() {
    return {
      list: [],
      openStatus: false,
    };
  },
  computed: mapState({
    config: (state) => state.config,
  }),
  props: {
    barcode: {
      type: Array,
      default: () => []
    }
  },
  mounted() {},
  methods: {
    // 筛选
    openSee() {
      const _this = this;
      _this.list = _this.barcode;
      _this.openStatus = true;
    },
    closeSee() {
      const _this = this;
      _this.list = [];
      _this.openStatus = false;
    },
  },
};
</script>